module.exports = __webpack_public_path__ + "static/media/3 5 tattoo chest lion majestic realism fierce noble.1280x1707.9e4e8e8f.webp";